import * as React from "react";
import { FC, MouseEventHandler } from "react";

// import { RichText } from "@mda/shared/rich-text";
import { NotificationLevel, INotification } from "@montana/containers/notification";

const notificationLevelModifiers = {
    [NotificationLevel.SUCCESS]: "notification--success",
    [NotificationLevel.INFO]: "notification--info",
    [NotificationLevel.WARN]: "notification--warn",
    [NotificationLevel.ERROR]: "notification--error"
};

export interface INotificationProps {
    notification: INotification;
    onClose: () => void;
    style?: React.CSSProperties;
    className?: string;
}

export const Notification: FC<INotificationProps> = React.memo(({ notification, style, className = "", onClose }: INotificationProps) => {
    const { message, notificationLevel } = notification;

    const handleClick: MouseEventHandler<HTMLDivElement> = e => {
        e.stopPropagation();
        onClose();
    };

    return (
        <div onClick={handleClick} className={`notification ${notificationLevelModifiers[notificationLevel]} ${className}`} style={style}>
            <div className="notification__content">
                {/* <RichText className="notification__text">{message}</RichText> #TODO */}
                <div className="notification__text text-sm">{message}</div>
            </div>
        </div>
    );
});
